/* eslint-disable no-console */
import { captureException } from '@sentry/react'
import { queryClient } from '@core/Data/ReactQuery'
import { serverConfigQuery } from '@core/Data/ServerConfig/query'

export function logError(message: string | Error, details?: unknown): void {
  logDebug(message, details)
  queryClient.fetchQuery(serverConfigQuery).then(config => {
    if (config.enableSentryIo && message instanceof Error) {
      captureException(message)
    }
  })
}

// =============
// Local Helpers
// =============

function logDebug(message: string | Error, details?: unknown): void {
  queryClient.fetchQuery(serverConfigQuery).then(
    config => {
      if (config.enableJsConsoleLogging && console) {
        if (message instanceof Error) {
          if (details) {
            console.error(message, details)
          } else {
            console.error(message)
          }
        } else {
          if (details) {
            console.log(message, details)
          } else {
            console.log(message)
          }
        }
      }
    },
    () => null /* don't care if there is no configuration */
  )
}
